import React, { useEffect, useState } from "react";
import {
    Grid,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    Chip,
    Box,
} from "@mui/material";

interface EditInverterStringsProps {
    inverterNumber: number;
    totalStrings: number;
    unavailableStrings: number[];
    isEditing: boolean;
    onStringsChange: (inverterNumber: number, strings: number[]) => void;
}

const EditInverterStrings: React.FC<EditInverterStringsProps> = ({
    inverterNumber,
    totalStrings,
    unavailableStrings,
    isEditing,
    onStringsChange,
}) => {
    const [selectedStrings, setSelectedStrings] = useState<number[]>(
        unavailableStrings || []
    );

    useEffect(() => {
        setSelectedStrings(unavailableStrings || []);
    }, [unavailableStrings]);

    const handleCheckboxToggle = (stringNumber: number) => {
        const newSelectedStrings = selectedStrings.includes(stringNumber)
            ? selectedStrings.filter((s) => s !== stringNumber)
            : [...selectedStrings, stringNumber];

        setSelectedStrings(newSelectedStrings);
        onStringsChange(inverterNumber, newSelectedStrings);
    };

    const renderChipValue = (selected: unknown) => {
        const selectedArray = selected as number[];
        return (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selectedArray.map((value) => (
                    <Chip key={value} label={value} size="small" />
                ))}
            </Box>
        );
    };

    // Gera array de números de 1 até totalStrings
    const stringNumbers = Array.from({ length: totalStrings }, (_, i) => i + 1);

    return (
        <Grid
            container
            sx={{
                padding: "15px",
                backgroundColor: "rgba(217, 217, 217, 0.05)",
                borderRadius: 1,
                marginBottom: "8px",
                alignItems: "center",
            }}
        >
            <Grid item xs={12} md={3}>
                <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                    Inversor {inverterNumber}
                </Typography>
            </Grid>

            <Grid item xs={12} md={9}>
                <FormControl
                    fullWidth
                    disabled={!isEditing}
                    sx={{
                        minWidth: "200px",
                    }}
                >
                    <InputLabel
                        id={`inverter-${inverterNumber}-strings-label`}
                        sx={{
                            top: selectedStrings.length > 0 ? 0 : "50%",
                            transform: "translateY(-50%)",
                            left: 10,
                            "&.Mui-focused": {
                                top: 0,
                                transform: "translateY(-50%)",
                                left: 10,
                            },
                        }}
                    >
                        Strings Desativadas
                    </InputLabel>
                    <Select
                        labelId={`inverter-${inverterNumber}-strings-label`}
                        id={`inverter-${inverterNumber}-strings`}
                        multiple
                        value={selectedStrings}
                        renderValue={renderChipValue}
                        sx={{
                            fontSize: "14px",
                            width: "100%",
                            minHeight: "35px",
                            borderRadius: "10px",
                        }}
                    >
                        <Box
                            sx={{
                                maxHeight: "200px",
                            }}
                        >
                            {stringNumbers.map((stringNumber) => (
                                <MenuItem
                                    key={stringNumber}
                                    value={stringNumber}
                                    onClick={() => handleCheckboxToggle(stringNumber)}
                                >
                                    <Checkbox checked={selectedStrings.includes(stringNumber)} />
                                    String {stringNumber}
                                </MenuItem>
                            ))}
                        </Box>
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
};

export default EditInverterStrings;
